import { YourFirstVisitPage } from "~/components/your-first-visit/YourFirstVisitPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/your-first-visit")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/your-first-visit"),
  component: YourFirstVisitPage,
});
